import Location from '@r6digital/rapidstor-types/react/entities/Location';

import { ReservationFeeSocketData, SocketStatus } from '@/core/types/Socket';

import useSettlementSocket from '@/core/hooks/useSettlementSocket';

interface UseReservationFeeSocketParams {
    location: Location;
}

export interface ReservationFeeCompletionHandlers {
    onSuccess?: (result: ReservationFeeSocketData) => void;
    onFailure?: (result: ReservationFeeSocketData) => void;
    onTimeout?: () => void;
}

interface UseReservationFeeSocketReturn {
    startListening: (
        reservationId: string,
        handlers?: ReservationFeeCompletionHandlers,
    ) => void;
    stopListening: () => void;
    latestResult: ReservationFeeSocketData | null;
    status: SocketStatus;
}

/**
 * Listens for `reservationFeeEvent` on the `reservation-fee:{reservationId}` room.
 *
 * With a payment gateway the fee is charged server-side — R6Pay takes the payment and its
 * webhook adds the fee to the reservation — so the browser returning from the gateway has
 * no way of knowing whether the fee actually landed. This is the mirror of
 * `useMoveInSocket` for the reservation-with-fee wizard.
 */
export const useReservationFeeSocket = ({
    location,
}: UseReservationFeeSocketParams): UseReservationFeeSocketReturn => useSettlementSocket<'reservation-fee'>({
    location,
    roomType: 'reservation-fee',
    roomPrefix: 'reservation-fee',
    logPrefix: '[useReservationFeeSocket]',
});

export default useReservationFeeSocket;
